import type { MailboxInfo } from 'owa-client-types';
import { getUserStore, setPreviousTableQueryMutator } from 'owa-mail-priority-inbox-store';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import { clearLastUndoableAction } from 'owa-mail-undo';
import { resetFocus } from 'owa-mail-focus-manager';

export async function closePriorityView(mailboxInfo: MailboxInfo): Promise<void> {
    const store = getUserStore(mailboxInfo);
    const previousTableQuery = store.previousTableQuery;

    if (!previousTableQuery) {
        return;
    }

    // Clear the stored previous table query
    setPreviousTableQueryMutator(mailboxInfo, undefined);

    clearLastUndoableAction();

    await loadTableViewFromTableQuery(
        previousTableQuery,
        undefined /* loadTableViewDatapoint */,
        undefined /* actionSource */
    );

    resetFocus('closePriorityView');
}
